import * as React from "react";
const SvgFiRrStage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stage_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-4.597l-4.282-4.121A2.8 2.8 0 0 0 13 17.205V6.414l1.591-1.591c.282.111.588.177.909.177A2.5 2.5 0 1 0 13 2.5c0 .322.066.627.177.909L8.293 8.293a.999.999 0 1 0 1.414 1.414L11 8.414v8.788a2.8 2.8 0 0 0-1.107.663L5.597 22H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2m-11.707-2.707a1.01 1.01 0 0 1 1.427.014L15.518 22H8.48z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stage_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStage;
